<template>
    <div class="team-tab container h-100">
        <div class="row h-100 text-center d-flex flex-column flex-lg-row">
            <div class="col-lg-6 pt-lg-5">
                
                <div class="row mb-2">
                    <div class="col p-0">
                        <b-button @click="$emit('openInvitations');btnSfx();" variant="hexagon" :class="'invitations'+(hasInvitations ? ' withBadge' : '')"><i></i></b-button>
                    </div>
                    <div class="col-5 p-0">
                        <img @click="$emit('openInfo');btnSfx();" src="/images/home/teams/create-team-bg.png">
                    </div>
                    <div class="col p-0">
                        <b-button @click="$emit('openInfo');btnSfx();" variant="hexagon" class="info"><i></i></b-button>
                    </div>
                </div>

                <p class="mb-lg-5" v-html="$t('home.home_team_ref_team_info')"></p>

                <div class="row mb-3 mb-lg-5">
                    <div class="col-6 pr-2">
                        <b-button  @click="$emit('openCreateRequest');btnSfx();" variant="primary" size="lg" class="p-3" block>{{ $t('home.home_team_ref_team_request_btn') }}</b-button>
                    </div>
                    <div class="col-6 pl-2">
                        <b-button  @click="$emit('openCreate');btnSfx();" variant="yellow" size="lg" class="p-3" block>{{ $t('home.home_team_ref_team_create_btn') }}</b-button>
                    </div>
                </div>

            </div>
            <div class="col-lg-6 flex-fill pt-lg-3 pb-lg-3">
                <b-tabs v-model="currentTab" content-class="h-100 relative" fill @activate-tab="tabSet">
                    <b-tab :title="$t('home.home_team_ref_top_teams_title')">
                        <ul v-if="topRankedTeams.length > 0" class="team-list">
                            <li v-for="r in topRankedTeams" :key="r.id">
                                <div :class="'team-list__order'+(r.rank <= 3 ? ' team-list__order--rank-'+r.rank : '')">{{ r.rank }}</div>
                                <h5 class="mb-0 ml-3">{{ r.team.name }}</h5>
                                <div class="team-list__right ml-auto">
                                    <span class="gameweek"><img src="/images/icon-trophy.png"/> <b>{{ r.points.abbr() }}</b></span>
                                    <!-- <span class="season"><img src="/images/icon-season-points.png"/> <b>{{ r.points.abbr() }}</b></span> -->
                                </div>
                            </li>
                        </ul>
                        <div v-else class="d-flex flex-fill p-3">
                            <span class="text-primary m-auto" v-html="$t('home.home_team_ref_top_teams_empty')"></span>
                        </div>
                    </b-tab>
                </b-tabs>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue'

import api from '../../api'

const NoTeamTab = Vue.component('no-team-tab', {

    props: {
        tab: 0
    },
    
    data(){
    	return {
            total: 0,
            topRankedTeams: [],
            hasInvitations: false,
    	};
    },
    
    methods:{

        btnSfx(){
            this.$store.dispatch('sound/sfx','Button');
        },

        tabSet(tab, silent){
            if(silent !== true) this.btnSfx();
            const $this = this;
        },

        setHasInvitations(has){
            this.hasInvitations = has;
        }
    },

    computed: {
        user() {
            return this.$store.state.auth.user;
        },
    },

    created(){
        const $this = this;
        this.currentTab = this.tab;
        this.tabSet(this.currentTab, true);

        api.teamsRankings()
        .then(res => {
            $this.topRankedTeams = res.data.allTeamRanks ?? [];
        })
        .catch(err => {
            api.baseErrorHendler(err);
        });

        api.teamsInvitations(1, 1)
        .then(res => {
            $this.hasInvitations = res.data.length > 0; 
        })
        .catch(err => {
            api.baseErrorHendler(err);
        });
    },

    beforeDestroy(){
        document.getElementById('loader').classList.remove("show");
    },

    watch: {
        tab(){
            this.currentTab = this.tab;
        }
    }

});

export default NoTeamTab
</script>
